import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBold = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5 6a3 3 0 0 1 3-3h2a4 4 0 0 1 3.045 6.594q.399.239.738.565A3.95 3.95 0 0 1 15 13a3.95 3.95 0 0 1-1.217 2.841A4.17 4.17 0 0 1 10.889 17H8a3 3 0 0 1-3-3zm2 5v3a1 1 0 0 0 1 1h2.889a2.17 2.17 0 0 0 1.506-.598c.392-.379.605-.883.605-1.402a1.95 1.95 0 0 0-.605-1.402A2.17 2.17 0 0 0 10.889 11zm0-2h3a2 2 0 0 0 0-4H8a1 1 0 0 0-1 1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBold;
